__turbopack_context__.v({
  "sidebar": "index-module-scss-module__2PmzWW__sidebar",
});
